import { render } from "./InviteToCollaborateOffPlatform.vue.js?vue&type=template&id=2d7aa356!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOffPlatform.vue?vue&type=template&id=2d7aa356"
import script from "./InviteToCollaborateOffPlatform.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOffPlatform.vue?vue&type=script&lang=js"
export * from "./InviteToCollaborateOffPlatform.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOffPlatform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/InviteToCollaborateOffPlatform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d7aa356"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d7aa356', __exports__)) {
    api.reload('2d7aa356', __exports__)
  }
  
  module.hot.accept("./InviteToCollaborateOffPlatform.vue.js?vue&type=template&id=2d7aa356!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOffPlatform.vue?vue&type=template&id=2d7aa356", () => {
    api.rerender('2d7aa356', render)
  })

}


export default __exports__